import {ItemGroup} from "./itemGroup";
import {Form} from '../form/form'
import {CellItem} from "../items/cellItem";

export class NoGroup extends ItemGroup<CellItem> {

    constructor(form: Form) {
        super({
            tag: "noGroup",
            attributes: {
                validate: "yes",
                id: "noGroup"
            },
            children: []
        }, form);
    }
}
